import React from 'react';
import { useTranslate } from 'react-redux-multilingual';

const Item = (props) => {

    return(
        <div className='row align-items-center'>
            <div className='col-12 text-center'>
                <button
                    type="button"
                    disabled={props.validButton}
                    className="btn btn-primary w-100"
                    style={{ minHeight: "80px", borderBottom: "1px solid black", fontSize: 20, backgroundColor:(props.pair)?'#0189d7':'#45a1d6ff' }}
                    onClick={() => props.onSubmit(props.datas,props.id)}
                >
                    {props.name}
                </button>
            </div>
        </div>
    )
}

const ModalKiosqueSelect = (props) =>{
    const t = useTranslate(); //Traduction
    
    return(
    <>
        <div className='row'>
            <div className='col-12'>
                {props.abonnementCard.abonnement_achat_article?.abonnement_article?.length!=0 && props.abonnementCard.abonnement_achat_article?.abonnement_article.map((value,ind) => (
                        <Item
                            key={value.id}
                            id={value.id}
                            name={value.kiosque_name}
                            onSubmit={props.onSubmit}
                            datas={props.datas}
                            validButton={props.validButton}
                            pair={(ind%2==0)?true:false}
                        />
                    )
                )
                }
            </div>
        </div>
    </>)
}

export default ModalKiosqueSelect;